export default __webpack_public_path__ + "static/media/default-avatar.475708e1.svg";